import SEO from '@/components/SEO';
import usePrerenderReady from '@/lib/usePrerenderReady';

const ArtsFoundation = () => {
  usePrerenderReady(false);
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-purple-50 pt-24">
      <SEO title="Arts Foundation" description="Arts foundations can use KalaManch.Art to discover emerging and established creative talent, support regional artists, and build stronger community programs, grants, showcases, and artistic development initiatives." />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12">
          <div className="text-6xl mb-6">🎨</div>
          <h1 className="text-4xl sm:text-5xl font-bold gradient-text mb-6">Arts Foundation</h1>
          <p className="text-lg text-gray-700 leading-8">
            Arts foundations can use KalaManch.Art to discover emerging and established creative talent, support
            regional artists, and build stronger community programs, grants, showcases, and artistic development
            initiatives.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ArtsFoundation;
